import React from 'react';
import { Box, Typography, Paper, Container } from '@mui/material';
import { BrandLogo } from './components/BrandLogo';
import { useThemeContext } from './context/ThemeContext';
import GoogleAuth from '../../Homepage/Login/components/GoogleAuth';

export const FlowstateLogin = () => {
    const { mode } = useThemeContext();
    const isLight = mode === 'light';

    const isReturningUser = !!localStorage.getItem('fs_has_visited');
    // Mark as visited so subsequent logins show "Welcome Back"
    React.useEffect(() => {
        localStorage.setItem('fs_has_visited', '1');
    }, []);

    return (
        <Box sx={{
            minHeight: '100vh',
            width: '100vw',
            maxWidth: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: isLight
                ? 'radial-gradient(ellipse at 50% 0%, #cbd5e1 0%, #f8fafc 65%)'
                : 'radial-gradient(ellipse at 50% 0%, #1c1c2e 0%, #0a0a0c 65%)',
        }}>
            <Container maxWidth="sm">
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <Box sx={{ mb: 4, transform: 'scale(1.2)' }}>
                        <BrandLogo size="large" isLight={isLight} />
                    </Box>
                    <Paper
                        elevation={0}
                        sx={{
                            p: 6,
                            width: '100%',
                            borderRadius: 6,
                            background: isLight ? 'rgba(255, 255, 255, 0.7)' : 'rgba(17, 17, 19, 0.6)',
                            backdropFilter: 'blur(10px)',
                            border: isLight ? '1px solid rgba(0, 0, 0, 0.05)' : '1px solid rgba(255, 255, 255, 0.05)',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            textAlign: 'center',
                            boxShadow: isLight
                                ? '0 30px 60px -12px rgba(0,0,0,0.1)'
                                : '0 30px 60px -12px rgba(0,0,0,0.5)',
                        }}
                    >
                        <Typography variant="h4" fontWeight="800" sx={{
                            mb: 2,
                            color: isLight ? '#1e293b' : '#f8fafc',
                            letterSpacing: '-0.5px'
                        }}>
                            {isReturningUser ? 'Welcome Back' : 'Welcome to FlowState'}
                        </Typography>
                        <Typography variant="body1" sx={{
                            color: isLight ? '#64748b' : '#94a3b8',
                            mb: 5,
                            lineHeight: 1.6
                        }}>
                            {isReturningUser
                                ? 'Sign in to continue your learning journey.'
                                : 'Sign in to get full access to all interactive visualizers and interview modules across the catalog.'}
                        </Typography>

                        <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                            <Box sx={{ 
                                bgcolor: isLight ? '#f8fafc' : '#111111', 
                                border: isLight ? '1px solid #e2e8f0' : '1px solid transparent',
                                px: 4, 
                                py: 3, 
                                borderRadius: 3,
                                width: '100%',
                                '& #google-login-btn': { display: 'flex', justifyContent: 'center', width: '100%' }
                            }}>
                                <GoogleAuth />
                            </Box>
                        </Box>
                        
                        <Typography variant="caption" sx={{ mt: 4, color: isLight ? '#94a3b8' : '#52525b' }}>
                            By continuing, you agree to FlowState's Terms of Service and Privacy Policy.
                        </Typography>
                    </Paper>
                </Box>
            </Container>
        </Box>
    );
};
